import { defaultTheme } from 'constants/theme/defaultTheme';
import styled from 'styled-components';
import { breakpoints } from 'stylesheet';

export const Styles = {
  MultiVariantsWrapper: styled.div`
    margin-top: ${defaultTheme.spacing(1)};
  `,
  ButtonContainer: styled.div`
    margin-top: ${defaultTheme.spacing(4)};
    display: flex;
    justify-content: center;
  `,
  ResultWrapper: styled.div`
    display: flex;
  `,
  ImageContainer: styled.div`
    background-color: ${defaultTheme.colors.snowGrey};
    border-radius: 8px;
    min-width: 118px;
    min-height: 118px;
    margin-right: ${defaultTheme.spacing(4)};
    @media (min-width: ${breakpoints.medium}) {
      min-width: 133px;
      min-height: 133px;
    }
  `,
};
